module.exports = __webpack_public_path__ + "img/Italy.05f6f98f.gif";